import { CATEGORY_COLORS, formatJMD, formatUSD, sumJmd } from '../../lib/finances';
import Pagination, { usePagination } from '../Pagination';
import Badge from '../Badge';

export default function EntryTable({ type, entries, onEdit, onDelete }) {
  const isExpense = type === 'expense';

  // Totals below stay across the whole period, not just this page — a
  // footer that silently totalled page 1 would be actively misleading.
  const { visible, controls } = usePagination(entries);

  if (entries.length === 0) {
    return <p className="entry-table-empty">No entries for this year yet.</p>;
  }

  return (
    <div className="entry-table-scroll">
      <table className="entry-table">
        <colgroup>
          <col className="col-date" />
          {isExpense && <col className="col-category" />}
          <col className="col-description" />
          {isExpense && <col className="col-vendor" />}
          {!isExpense && <col className="col-order" />}
          {!isExpense && <col className="col-channel" />}
          {!isExpense && <col className="col-payment" />}
          <col className="col-amount" />
          <col className="col-amount" />
          <col className="col-actions" />
        </colgroup>
        <thead>
          <tr>
            <th>Date</th>
            {isExpense && <th>Category</th>}
            <th>{isExpense ? 'Description' : 'Description / customer'}</th>
            {isExpense && <th>Vendor</th>}
            {!isExpense && <th>Order #</th>}
            {!isExpense && <th>Channel</th>}
            {!isExpense && <th>Payment</th>}
            <th>Amount</th>
            <th>JMD</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {visible.map((entry) => (
            <tr key={entry.id}>
              <td className="entry-table-nowrap">{entry.entry_date}</td>
              {isExpense && (
                <td className="entry-table-nowrap">
                  <Badge
                    style={{
                      background: CATEGORY_COLORS[entry.category]?.bg,
                      color: CATEGORY_COLORS[entry.category]?.text,
                    }}
                    title={entry.category}
                  >
                    {entry.category}
                  </Badge>
                </td>
              )}
              <td className="entry-table-clamp" title={entry.description}>
                {entry.description}
              </td>
              {isExpense && (
                <td className="entry-table-truncate" title={entry.vendor || ''}>
                  {entry.vendor || '—'}
                </td>
              )}
              {!isExpense && (
                <td className="entry-table-truncate">{entry.order_number || '—'}</td>
              )}
              {!isExpense && <td className="entry-table-nowrap">{entry.channel || '—'}</td>}
              {!isExpense && (
                <td className="entry-table-nowrap">{entry.payment_method || '—'}</td>
              )}
              <td className="entry-table-nowrap entry-table-numeric">
                {entry.currency === 'USD' ? formatUSD(entry.amount) : formatJMD(entry.amount)}
              </td>
              <td className="entry-table-nowrap entry-table-numeric">
                {formatJMD(entry.amount_jmd)}
              </td>
              <td className="entry-table-actions">
                <button className="entry-table-edit" onClick={() => onEdit(entry)}>
                  Edit
                </button>
                <button className="entry-table-delete" onClick={() => onDelete(entry.id)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={isExpense ? 4 : 5} className="entry-table-total-label">
              Total
            </td>
            <td className="entry-table-total-value entry-table-numeric" colSpan={2}>
              {formatJMD(sumJmd(entries))}
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>

      <Pagination {...controls} />
    </div>
  );
}
